var each = require('./each'),
    extend = require('./extend');

module.exports = serialize;

function serialize(data){
  var query = [];
  each(data, function(value, key){
    if ('string' !== typeof value) {
      value = JSON.stringify(value);
    }
    query.push(key + '=' + encodeURIComponent(value));
  });
  return query.join('&');
}



//////////////////
// WEBPACK FOOTER
// ./~/keen-core/lib/utils/serialize.js
// module id = 1962
// module chunks = 0